export const GET_AFFILIATES_BANNER_SLIDES_START = 'GET_AFFILIATES_BANNER_SLIDES_START';
export const GET_AFFILIATES_BANNER_SLIDES_SUCCESS = 'GET_AFFILIATES_BANNER_SLIDES_SUCCESS';
export const GET_AFFILIATES_BANNER_SLIDES_FAILED = 'GET_AFFILIATES_BANNER_SLIDES_FAILED';

export const ADD_AFFILIATES_BANNER_SLIDE_START = 'ADD_AFFILIATES_BANNER_SLIDE_START';
export const ADD_AFFILIATES_BANNER_SLIDE_SUCCESS = 'ADD_AFFILIATES_BANNER_SLIDE_SUCCESS';
export const ADD_AFFILIATES_BANNER_SLIDE_FAILED = 'ADD_AFFILIATES_BANNER_SLIDE_FAILED';

export const DELETE_AFFILIATES_BANNER_SLIDE_START = 'DELETE_AFFILIATES_BANNER_SLIDE_START';
export const DELETE_AFFILIATES_BANNER_SLIDE_SUCCESS = 'DELETE_AFFILIATES_BANNER_SLIDE_SUCCESS';
export const DELETE_AFFILIATES_BANNER_SLIDE_FAILED = 'DELETE_AFFILIATES_BANNER_SLIDE_FAILED';


export const EDIT_AFFILIATES_BANNER_SLIDE_START = 'EDIT_AFFILIATES_BANNER_SLIDE_START';
export const EDIT_AFFILIATES_BANNER_SLIDE_SUCCESS = 'EDIT_AFFILIATES_BANNER_SLIDE_SUCCESS';
export const EDIT_AFFILIATES_BANNER_SLIDE_FAILED = 'EDIT_AFFILIATES_BANNER_SLIDE_FAILED';

export const GET_FULLFILMENT_BANNER_SLIDES_START = 'GET_FULLFILMENT_BANNER_SLIDES_START';
export const GET_FULLFILMENT_BANNER_SLIDES_SUCCESS = 'GET_FULLFILMENT_BANNER_SLIDES_SUCCESS';
export const GET_FULLFILMENT_BANNER_SLIDES_FAILED = 'GET_FULLFILMENT_BANNER_SLIDES_FAILED';

export const ADD_FULLFILMENT_BANNER_SLIDE_START = 'ADD_FULLFILMENT_BANNER_SLIDE_START';
export const ADD_FULLFILMENT_BANNER_SLIDE_SUCCESS = 'ADD_FULLFILMENT_BANNER_SLIDE_SUCCESS';
export const ADD_FULLFILMENT_BANNER_SLIDE_FAILED = 'ADD_FULLFILMENT_BANNER_SLIDE_FAILED';

export const DELETE_FULLFILMENT_BANNER_SLIDE_START = 'DELETE_FULLFILMENT_BANNER_SLIDE_START';
export const DELETE_FULLFILMENT_BANNER_SLIDE_SUCCESS = 'DELETE_FULLFILMENT_BANNER_SLIDE_SUCCESS';
export const DELETE_FULLFILMENT_BANNER_SLIDE_FAILED = 'DELETE_FULLFILMENT_BANNER_SLIDE_FAILED';


export const EDIT_FULLFILMENT_BANNER_SLIDE_START = 'EDIT_FULLFILMENT_BANNER_SLIDE_START';
export const EDIT_FULLFILMENT_BANNER_SLIDE_SUCCESS = 'EDIT_FULLFILMENT_BANNER_SLIDE_SUCCESS';
export const EDIT_FULLFILMENT_BANNER_SLIDE_FAILED = 'EDIT_FULLFILMENT_BANNER_SLIDE_FAILED';

export const GET_AFFILIATE_PROVIDERS_START = 'GET_AFFILIATE_PROVIDERS_START';
export const GET_AFFILIATE_PROVIDERS_SUCCESS = 'GET_AFFILIATE_PROVIDERS_SUCCESS';
export const GET_AFFILIATE_PROVIDERS_FAILED = 'GET_AFFILIATE_PROVIDERS_FAILED';

export const GET_STORE_AFFILIATES_START = 'GET_STORE_AFFILIATES_START';
export const GET_STORE_AFFILIATES_SUCCESS = 'GET_STORE_AFFILIATES_SUCCESS';
export const GET_STORE_AFFILIATES_FAILED = 'GET_STORE_AFFILIATES_FAILED';

export const ADD_AFFILIATE_TO_STORE_START = 'ADD_AFFILIATE_TO_STORE_START';
export const ADD_AFFILIATE_TO_STORE_SUCCESS = 'ADD_AFFILIATE_TO_STORE_SUCCESS';
export const ADD_AFFILIATE_TO_STORE_FAILED = 'ADD_AFFILIATE_TO_STORE_FAILED';

export const SEND_REQUEST_PRODUCTS_EMAIL_START = 'SEND_REQUEST_PRODUCTS_EMAIL_START';
export const SEND_REQUEST_PRODUCTS_EMAIL_SUCCESS = 'SEND_REQUEST_PRODUCTS_EMAIL_SUCCESS';
export const SEND_REQUEST_PRODUCTS_EMAIL_FAILED = 'SEND_REQUEST_PRODUCTS_EMAIL_FAILED';

export const getAffiliatesBannerSlidesStart = () => ({
  type: GET_AFFILIATES_BANNER_SLIDES_START
});

export const getAffiliatesBannerSlidesSuccess = (data) => ({
  type: GET_AFFILIATES_BANNER_SLIDES_SUCCESS,
  data
});

export const getAffiliatesBannerSlidesFailed = (error) => ({
  type: GET_AFFILIATES_BANNER_SLIDES_FAILED,
  error
});

export const addAffiliatesBannerSlideStart = () => ({
  type: ADD_AFFILIATES_BANNER_SLIDE_START
});

export const addAffiliatesBannerSlideSuccess = (data) => ({
  type: ADD_AFFILIATES_BANNER_SLIDE_SUCCESS,
  data
});

export const addAffiliatesBannerSlideFailed = (error) => ({
  type: ADD_AFFILIATES_BANNER_SLIDE_FAILED,
  error
});

export const deleteAffiliatesBannerSlideStart = () => ({
  type: DELETE_AFFILIATES_BANNER_SLIDE_START
});

export const deleteAffiliatesBannerSlideSuccess = (id) => ({
  type: DELETE_AFFILIATES_BANNER_SLIDE_SUCCESS,
  id
});

export const deleteAffiliatesBannerSlideFailed = (error) => ({
  type: DELETE_AFFILIATES_BANNER_SLIDE_FAILED,
  error
});

export const editAffiliatesBannerSlideStart = () => ({
  type: EDIT_AFFILIATES_BANNER_SLIDE_START
});

export const editAffiliatesBannerSlideSuccess = (data, id) => ({
  type: EDIT_AFFILIATES_BANNER_SLIDE_SUCCESS,
  data,
  id
});

export const editAffiliatesBannerSlideFailed = (error) => ({
  type: EDIT_AFFILIATES_BANNER_SLIDE_FAILED,
  error
});

export const getFullfilmentBannerSlidesStart = () => ({
  type: GET_FULLFILMENT_BANNER_SLIDES_START
});

export const getFullfilmentBannerSlidesSuccess = (data) => ({
  type: GET_FULLFILMENT_BANNER_SLIDES_SUCCESS,
  data
});

export const getFullfilmentBannerSlidesFailed = (error) => ({
  type: GET_FULLFILMENT_BANNER_SLIDES_FAILED,
  error
});

export const addFullfilmentBannerSlideStart = () => ({
  type: ADD_FULLFILMENT_BANNER_SLIDE_START
});

export const addFullfilmentBannerSlideSuccess = (data) => ({
  type: ADD_FULLFILMENT_BANNER_SLIDE_SUCCESS,
  data
});

export const addFullfilmentBannerSlideFailed = (error) => ({
  type: ADD_FULLFILMENT_BANNER_SLIDE_FAILED,
  error
});

export const deleteFullfilmentBannerSlideStart = () => ({
  type: DELETE_FULLFILMENT_BANNER_SLIDE_START
});

export const deleteFullfilmentBannerSlideSuccess = (id) => ({
  type: DELETE_FULLFILMENT_BANNER_SLIDE_SUCCESS,
  id
});

export const deleteFullfilmentBannerSlideFailed = (error) => ({
  type: DELETE_FULLFILMENT_BANNER_SLIDE_FAILED,
  error
});

export const editFullfilmentBannerSlideStart = () => ({
  type: EDIT_FULLFILMENT_BANNER_SLIDE_START
});

export const editFullfilmentBannerSlideSuccess = (data, id) => ({
  type: EDIT_FULLFILMENT_BANNER_SLIDE_SUCCESS,
  data,
  id
});

export const editFullfilmentBannerSlideFailed = (error) => ({
  type: EDIT_FULLFILMENT_BANNER_SLIDE_FAILED,
  error
});

export const getAffiliateProvidersStart = () => ({
  type: GET_AFFILIATE_PROVIDERS_START
});

export const getAffiliateProvidersSuccess = (data) => ({
  type: GET_AFFILIATE_PROVIDERS_SUCCESS,
  data
});

export const getAffiliateProvidersFailed = (error) => ({
  type: GET_AFFILIATE_PROVIDERS_FAILED,
  error
});

export const getStoreAffiliatesStart = () => ({
  type: GET_STORE_AFFILIATES_START
});

export const getStoreAffiliatesSuccess = (data) => ({
  type: GET_STORE_AFFILIATES_SUCCESS,
  data
});

export const getStoreAffiliatesFailed = (error) => ({
  type: GET_STORE_AFFILIATES_FAILED,
  error
});

export const addAffiliateToStoreStart = () => ({
  type: ADD_AFFILIATE_TO_STORE_START
});

export const addAffiliateToStoreSuccess = (data) => ({
  type: ADD_AFFILIATE_TO_STORE_SUCCESS,
  data
});

export const addAffiliateToStoreFailed = (error) => ({
  type: ADD_AFFILIATE_TO_STORE_FAILED,
  error
});

export const sendRequestProductsEmailStart = () => ({
  type: SEND_REQUEST_PRODUCTS_EMAIL_START,
});

export const sendRequestProductsEmailSuccess = () => ({
  type: SEND_REQUEST_PRODUCTS_EMAIL_SUCCESS,
});

export const sendRequestProductsEmailFailed = (error) => ({
  type: SEND_REQUEST_PRODUCTS_EMAIL_FAILED,
  error
});
